const { default: postData } = require('../../dataFetcher/postDataFetcher');

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function loginCall(data) {
  const result = await postData(`${backendUrl}login`, data);
  return result;
}
